import { NAVIGATION_THRESHOLD_MS } from '../constants/Global';
import { logError } from './ApiHelper';
import { logCustomNegativeExperience } from './commonUtils';

let pendingStart: number | null = null;
let pendingFromPage = '';
let observer: PerformanceObserver | null = null;

const getCurrentPath = () => window.location.pathname + window.location.search;

const logSlowNavigation = (previousPage: string, currentPage: string, navigationTime: number) => {
  logCustomNegativeExperience({
    message: `Slow navigation: ${navigationTime.toFixed(2)}ms`,
    extras: {
      type: 'SLOW_NAVIGATION',
      previousPage,
      currentPage,
      navigationTime,
      threshold: NAVIGATION_THRESHOLD_MS,
      timestamp: Date.now(),
      userAgent: navigator.userAgent,
      url: window.location.href
    }
  });
};

export const startNavigation = (fromPage?: string) => {
  const startTime = performance.now();
  const sourcePage = fromPage || getCurrentPath();

  pendingStart = startTime;
  pendingFromPage = sourcePage;
};

export const completeNavigation = (toPage?: string) => {
  if (pendingStart === null) {
    return;
  }

  const endTime = performance.now();
  const duration = endTime - pendingStart;
  const destination = toPage || getCurrentPath();

  if (duration > NAVIGATION_THRESHOLD_MS) {
    logSlowNavigation(pendingFromPage, destination, duration);
  }

  pendingStart = null;
};

export const getNavigationStats = () => {
  const stats = {
    threshold: NAVIGATION_THRESHOLD_MS,
    hasPendingNavigation: pendingStart !== null,
    pendingNavigationStartTime: pendingStart
  };

  return stats;
};

export const destroyNavigationTracker = () => {
  pendingStart = null;

  if (observer) {
    observer.disconnect();
    observer = null;
  }
};

export const initNavigationObserver = (): void => {
  if (observer || typeof PerformanceObserver === 'undefined') {
    return;
  }

  observer = new PerformanceObserver(list => {
    list.getEntries().forEach(entry => {
      if (entry.entryType === 'navigation') {
        const nav = entry as PerformanceNavigationTiming;
        const duration = nav.loadEventEnd - nav.startTime;

        if (duration > NAVIGATION_THRESHOLD_MS) {
          logSlowNavigation('browser-navigation', getCurrentPath(), duration);
        }
      }
    });
  });

  try {
    observer.observe({ entryTypes: ['navigation'] });
  } catch (error) {
    logError(error, 'Navigation observer initialization failed');
  }
};
